<div class="header">
    <h2>Aggiunta <strong>Documento</strong></h2>
    <div class="breadcrumb-wrapper hidden-xs">
        <ol class="breadcrumb">
            <li><a style="cursor: pointer;" [routerLink]="['/reservation']">Ispezioni</a></li>
            <li><a style="cursor: pointer;" [routerLink]="['/inspection/' + document.fk_id_inspection]">Dettaglio Ispezione</a></li>
            <li class="active">Aggiunta Documento</li>
        </ol>
    </div>
</div>
<div class="row">
    <div class="col-md-12">
        <div class="panel">
            <div class="panel-content">
                <form (ngSubmit)="onSubmit()" #inspectionImportForm="ngForm" role="form"
                      class="form-horizontal form-validation">
                    <div class="row" style="margin-top: 80px; margin-bottom: 80px;">
                        <div class="col-md-6 col-md-offset-3">
                            <div class="form-group">
                                <label for="document" class="col-sm-3 control-label">Documento *</label>
                                <div class="col-sm-3">
                                    <span class="input-group-btn">
                                        <label class="btn btn-primary">Seleziona File
                                            <input type="file"
                                                   id="document"
                                                   name="document"
                                                   (change)="onFileSelected($event)"
                                                   required
                                                   hidden>
                                        </label>
                                    </span>
                                </div>
                                <div class="col-sm-6">
                                    <input type="text"
                                           id="inspection-document"
                                           name="inspection-document"
                                           class="form-control-plaintext"
                                           style="font-size: 1.4rem !important;"
                                           readonly
                                           [ngModel]="fileName || 'Nessun file selezionato'">
                                </div>
                            </div>

                            <div class="text-center m-t-20" style="margin-top: 50px !important;">
                                <button type="submit"
                                        class="btn btn-embossed btn-success"
                                        [disabled]="!inspectionImportForm.form.valid || fileName === ''">
                                    <i class="fa fa-upload"></i> Carica Documento
                                </button>
                            </div>

                            <div *ngIf="inspectionDocumentUploadResult === false" class="alert alert-danger">
                                Impossibile caricare il file, verificarne il formato e riprovare.
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
